<!-- eslint-disable import/no-duplicates -->
<template>
  <div class="main_context parent">
    <div class="context parent" style="max-width: 1700px;min-height: 1650px;">
      <el-container style="height: 100%; margin: 0 auto;">
        <div class="content_tree">
          <el-menu default-active="1" :default-openeds="openeArray" class="el-menu-vertical-demo" @open="handleOpen"
            @close="handleClose" :collapse="isCollapse">
            <!-- login : true -->
            <div v-if="this.login">
              <div v-for="(item, index) in categoryTree" :key="index">
                <div v-if="check(item.isLogin)">
                <div v-if="item.parentId == -1">
                  <el-submenu :index="readindex(item.id)">
                    <template slot="title">
                      <i :class="item.cateImg"></i>
                      <span slot="title" @click="
                        switchoverMenu(
                          item.categoryCode,
                          item.id,
                          item.outsideChain,
                          item.skipUrl)
                        " style="padding-right: 60px;line-height: 100%;width: 205px;">{{ item.categoryName }}</span>
                    </template>

                    <div v-for="(category, indexs) in item.children" :key="indexs">
                      <div v-if="(item.id == category.parentId)&&check(category.isLogin)">
                        <!-- <span slot="title">分组一</span> -->
                        <el-menu-item :index="readindex(category.id)" @click=" switchoverMenu(
                          category.categoryCode,
                          category.id,
                          category.outsideChain,
                          category.skipUrl)
                          " style="width: 100%; padding-left: 70px;">{{ category.categoryName }}</el-menu-item>
                      </div>
                    </div>
                  </el-submenu>
                </div>
                </div>
              </div>
            </div>

            <!--login : false -->
            <div v-else-if="this.login == false">
              <div v-for="(item, index) in categoryTree" :key="index">
                <div v-if="item.isLogin == 1">
                  <div v-if="item.parentId == -1">
                    <el-submenu :index="readindex(item.id)">
                      <template slot="title">
                        <i :class="item.cateImg"></i>
                        <span slot="title" @click="
                          switchoverMenu(
                            item.categoryCode,
                            item.id,
                            item.outsideChain,
                            item.skipUrl
                          )
                          " style="width: 205px;display: inline-block;">{{ item.categoryName }}</span>
                      </template>

                      <div v-for="(category, indexs) in item.children" :key="indexs">
                        <div v-if="category.isLogin == 1 && item.id == category.parentId">
                          <!-- <span slot="title">分组一</span> -->
                          <el-menu-item :index="readindex(category.id)" @click="
                            switchoverMenu(
                              category.categoryCode,
                              category.id,
                              category.outsideChain,
                              category.skipUrl
                            )
                            " style="width: 205px; padding-left: 70px;">{{ category.categoryName }}</el-menu-item>
                        </div>
                      </div>
                    </el-submenu>
                  </div>
                </div>
              </div>
            </div>
          </el-menu>
        </div>

        <el-container style="width: auto;">
          <div class="container_context" style="width: 100%;">
            <!-- 动态组件加载 -->
            <component :is="currentComponent"></component>
          </div>
        </el-container>
      </el-container>
    </div>
    <!-- <div class="content_end">
        <div>
        </div>
      </div> -->
    <!-- End Google Tag Manager (noscript) ke fu tu biao-->
    <div class="side_fix">
      <ul>
        <li>
          <a href="https://www.sigenergy.com/en/contact" target="_blank">
            <div class="sidebox"><img src="/static/img/side_icon03.png">Contact Us</div>
          </a>
        </li>
        <li>
          <a href="mailto:sales@sigenergy.com" target="_blank">
            <div class="sidebox"><img src="/static/img/side_icon04.png">Email us</div>
          </a>
        </li>
        <li class="side-go-top">
          <a class="sidetop"><img src="/static/img/side_icon05.png"></a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import 'element-ui/lib/theme-chalk/index.css';
import { categoryList } from "@/api/exam/main";
import BecomePartnerComponent from "@/components/BecomePartner/index.vue";
// 文档中心
// eslint-disable-next-line import/no-duplicates
import TechnicalComponent from '@/components/Technical/index.vue'
// eslint-disable-next-line import/no-duplicates
import TechnicalComponentInstall from "@/components/Technical/index.vue"
// eslint-disable-next-line import/no-duplicates
import TechnicalComponentMaintenance from "@/components/Technical/index.vue"
// eslint-disable-next-line import/no-duplicates
import TechnicalComponentTransport from "@/components/Technical/index.vue"
// eslint-disable-next-line import/no-duplicates
import teComponent from "@/components/Technical/index.vue"
// 培训中心
// eslint-disable-next-line import/no-duplicates
import courseComponent from "@/components/sigen/course/index.vue";
// eslint-disable-next-line import/no-duplicates, camelcase
import all_courseComponent from "@/components/sigen/course/index.vue";
// 技术通知
import notificationComponent from "@/components/sigen/notification/index.vue";
import changeNoticeComponent from "@/components/sigen/changeNotice/index.vue";
// 常见问题
import problemComponent from "@/components/sigen/problem/index.vue";
// 质保条款
import warrantyComponent from "@/components/sigen/warranty/index.vue";
import LibraryComponent from "@/components/sigen/library/index.vue";

export default {
  provide() {
    return {
      getCateId: () => this.cateId
    };
  },
  data() {
    return {
      language: this.$i18n.locale,
      loading: true,
      show: 1,
      login: false,
      installer: false, // 是否为安装商
      section: {},
      categoryTree: {},
      openeArray: [],
      isCollapse: false,
      isLogin: 0,
      lang: "en",
      cateId: 2, // 默认首页菜单ID
      // 当前要加载的组件名
      currentComponent: "technical-component"
    };
  },
  components: {
    "library-component": LibraryComponent,
    "becomePartner-component": BecomePartnerComponent,
    "becomePartner-component_zh": BecomePartnerComponent,
    "becomePartner-component_en": BecomePartnerComponent,
    "becomePartner-component_es": BecomePartnerComponent,
    "becomePartner-component_de": BecomePartnerComponent,

    "becomePartner-install_zh": TechnicalComponentInstall,
    "becomePartner-maintenance_zh": TechnicalComponentMaintenance,
    "becomePartner-transport_zh": TechnicalComponentTransport,

    "becomePartner-install_en": TechnicalComponentInstall,
    "becomePartner-maintenance_en": TechnicalComponentMaintenance,
    "becomePartner-transport_en": TechnicalComponentTransport,
    "becomePartner-storage_en": TechnicalComponentTransport,

    "becomePartner-install_es": TechnicalComponentInstall,
    "becomePartner-maintenance_es": TechnicalComponentMaintenance,
    "becomePartner-transport_es": TechnicalComponentTransport,

    "becomePartner-install_de": TechnicalComponentInstall,
    "becomePartner-maintenance_de": TechnicalComponentMaintenance,
    "becomePartner-transport_de": TechnicalComponentTransport,

    "technical-component": TechnicalComponent,
    "course-Component_zh": courseComponent,
    "course-Component_en": courseComponent,
    "course-Component_de": courseComponent,
    "course-Component_es": courseComponent,
    "all_courseComponent": all_courseComponent,
    // 技术通知
    'notificationComponent_zh': notificationComponent,
    'notificationComponent_en': notificationComponent,
    'notificationComponent_es': notificationComponent,
    'notificationComponent_de': notificationComponent,
    // 变更通知
    'changeNoticeComponent_zh': changeNoticeComponent,
    'changeNoticeComponent_en': changeNoticeComponent,
    'changeNoticeComponent_es': changeNoticeComponent,
    'changeNoticeComponent_de': changeNoticeComponent,

    // 常见问题
    'problemComponent_zh': problemComponent,
    'problemComponent_en': problemComponent,
    'problemComponent_es': problemComponent,
    'problemComponent_de': problemComponent,
    // 质保条款
    'warrantyComponent_zh': warrantyComponent,
    'warrantyComponent_en': warrantyComponent,
    'warrantyComponent_es': warrantyComponent,
    'warrantyComponent_de': warrantyComponent,

    teComponent
  },
  created() {
    this.installer = false;
    let lang = this.getRouteParams();
    if (lang === undefined)lang = "en";
    this.handleSetLanguage(lang);
    this.checkLogin();
    this.lang = lang;
    this.categoryList(this.isLogin, lang);
    // 根据不同路由跳转不同页面
    if (this.isMobile()) {
      console.log("Mobile client");
      const url = "https://msupport.sigenergy.com/ ";
      // 打开新窗口
      window.open(url, '_self');
    } else {
      console.log("PC client");
    }
  },
  mounted() {
    // 根据不同路由跳转不同页面
    if (this.isMobile()) {
      console.log("Mobile client");
      const url = "https://msupport.sigenergy.com/ ";
      // 打开新窗口
      window.open(url, '_self');
    } else {
      console.log("PC client");
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo
    })
  },
  methods: {
    readindex(ind) {
      return ind.toString();
    },
    // 该方法用于判断是否进入手机端
    isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    check(isLogin) {
      this.checkLogin();
      // console.log("---------------->check:" + this.login);
      // eslint-disable-next-line eqeqeq
      if (this.login) {
        return true;
      } else if (this.installer !== undefined && this.installer === true) {
        return true;
      } else {
        return false;
      }
    },
    checkLogin() {
      if (this.userInfo.id !== undefined) {
        this.login = true;
        //console.log("---------------->checklogin:" + this.login);
        if (this.login) {
          this.isLogin = 0;
        } else {
          this.isLogin = 1;
        }
      }
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    getRouteParams() {
      // 使用 let phone=this.$route.query.name 来获Get请求参数的值
      let lang = this.$route.query.lang;
      let flag = this.$route.query.flag;
      console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>1 getRouteParams  flag  :', flag);
      if (flag !== undefined && flag === '51') {
        console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>2 getRouteParams  flag  :', flag);
        this.currentComponent = "problemComponent_en";
        this.cateId = 51;
      } else if (flag !== undefined && flag === '48') {
        console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>3 getRouteParams  flag  :', flag);
        this.currentComponent = "all_courseComponent";
        this.cateId = 48;
      } else if (flag !== undefined && flag === '1003') {
        console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>4 getRouteParams  flag  :', flag);
        this.currentComponent = "library-component";
        this.cateId = 1003;
      }
      return lang;
    },
    handleSetLanguage(lang) {
      this.$i18n.locale = lang;
      this.language = lang;
    },
    categoryList(isLogin, lang) {
      if (lang === undefined) {
        return;
      }
      categoryList(isLogin, lang)
        .then((res) => {
          this.categoryTree = res.data.result.listTree;
          let install = this.userInfo.wechat;
          if (install != null && install === "installer") this.installer = true;
          console.log("-------------------->installer:" + this.installer);
          this.openeArray = res.data.result.listId;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    goBack() {
      if (this.$refs.sectionVideo) {
        this.$refs.sectionVideo.pause();
      }
      this.$router.go(-1);
    },
    switchoverMenu(val, id, out, url) {
      if (out === 0) {
        this.currentComponent = val;
        this.cateId = id;
      } else {
        window.open(url, "_blank");
      }
    }
  }
};
</script>

<style scoped="scoped" lang="scss">
.main_context {
  width: 100%;
  min-height: 1650px;
  max-width: 5400px;
  /* 设置最大宽度，防止过度放大 */
  background: #ffffff;
  margin-left: auto;
  margin-right: auto;
  font-family: "Open Sans", sans-serif;
}

.context {
  width: 90%;
  height: 100%;
  margin: 0 auto;
  margin-left: auto;
  margin-right: auto;
  background:#fff;
  font-family: "Open Sans", sans-serif;
}

.content_tree {
  width: "230px";
  height: 100%;
}

.container {
  height: 100%;
  border: 1px solid #ffffff;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  height: 100%;
  //min-height: 3600px;
}

.content_end {
  margin-left: 50px;
  position: absolute;
  top: 100%;
  /* 将子容器放置在父容器下方 */
  height: 30px;
  width: 80%;
  margin: 0 auto;
  text-align: center;
}

// 树目录样式
.all_sigen {
  width: 65%;
  align-items: center;
}

.container_context {
  height: 100%;
  background: #ffffff;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

/* side */
.side_fix {
  position: fixed;
  width: 54px;
  min-height: 200px;
  right: 2%;
  bottom: 10%;
  z-index: 100;
}

.side_fix ul li {
  width: 54px;
  height: 54px;
  float: left;
  position: relative;
  margin-top: 5px;
}

.side_fix ul li .sidebox {
  position: absolute;
  width: 54px;
  height: 54px;
  top: 0;
  line-height: 54px;
  right: 0;
  transition: all 0.3s;
  background: #00B5B1;
  filter: Alpha(opacity=80);
  color: #fff;
  overflow: hidden;
  border-radius: 30px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
}

.side_fix ul li .sidetop {
  width: 54px;
  height: 54px;
  line-height: 54px;
  display: inline-block;
  background: #00B5B1;
  filter: Alpha(opacity=80);
  transition: all 0.3s;
  border-radius: 30px;
}

.side_fix ul li .sidetop:hover {
  background: #00B5B1;
  opacity: 1;
  filter: Alpha(opacity=100);
}

.side_fix ul li img {
  float: left;
}

.side_fix ul .side-go-top {
  display: none;
  border: 0px;
}

@media screen and (max-width: 768px) {
  .side_fix {
    transform: scale(0.7);
  }
}

/* 隐藏垂直滚动条 */
.parent::-webkit-scrollbar {
  width: 0;
}

/* 隐藏水平滚动条 */
.parent::-webkit-scrollbar {
  height: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/main/main.vue